import { withParams } from 'vuelidate'

export const checkIfSet = withParams(
  { type: 'required' },
  value => (value !== null ? false : true)
)